import columns from '../../../../../react-table/helpers/columns';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';
import {
  sumOfGroupTotals,
  totalRowPercentageWithGrandTotals,
} from '../../../../../react-table/helpers/rowTotals';
import Resdit7421PerformanceLocationReportMode from "./Resdit7421PerformanceLocationReportMode";

export const getLocationTabNavigationProps = originExchangeOfficesData => (rowInfo, index) => (
  rowInfo && rowInfo.row ? {
    reportId: ReportDefinitions.RESDIT_74_21_PERFORMANCE_DETAILS_107B.id,
    mainReportId: ReportDefinitions.RESDIT_74_21_PERFORMANCE_LOCATION_107B.id,
    requestParams: {
      carrier: rowInfo.row['cardit.carrier'],
      origin: rowInfo.row['cardit.origins'][index],
      destination: rowInfo.row['cardit.destinations'][index],
      originExchangeOffices: originExchangeOfficesData.originExchangeOffices,
      isSubtotal: index === 0,
    },
    selectionCriteriaOptions: {
      includeSelectionCriteria: true,
    },
  } : {}
);

export default (data, originExchangeOfficesData, mode = Resdit7421PerformanceLocationReportMode.percentage) => {
  const {
    NonZeroNumberColumn,
    MultilineColumn,
    MultilineNumberGroupedColumn,
    MultilinePercentageGroupedColumn,
    MultilineNumberNavigationWithFooterColumn,
  } = columns(data);

  return [
    {
      Header: 'CARDIT',
      columns: [
        new MultilineColumn('Carrier', 'cardit.carrier')
          .withTotalHeader('Total', 'bg-total-darkGrey'),
        new MultilineColumn('Origin', 'cardit.origins')
          .withTotalHeader('', 'bg-total-darkGrey'),
        new MultilineColumn('Destination', 'cardit.destinations')
          .withTotalHeader('', 'bg-total-darkGrey'),
        new MultilineNumberNavigationWithFooterColumn(
          new NonZeroNumberColumn('Total', 'cardit.totals')
            .withTotalHeader(sumOfGroupTotals, 'bg-total-darkGrey'),
          getLocationTabNavigationProps(originExchangeOfficesData),
        ),
      ],
      drillDownLink: {
        reportId: ReportDefinitions.RESDIT_74_21_PERFORMANCE_DETAILS_107B.id,
        mainReportId: ReportDefinitions.RESDIT_74_21_PERFORMANCE_LOCATION_107B.id,
        requestParams: {
          isTotal: originExchangeOfficesData.carrier === '*', // since report expected to have one only group - * is handled on cape-be by reverting it back to ''
          isSubtotal: originExchangeOfficesData.carrier !== '*', // since report expected to have one only group - * is handled on cape-be by reverting it back to ''
          carrier: originExchangeOfficesData.carrier,
        },
        selectionCriteriaOptions: {
          includeSelectionCriteria: true,
        },
      },
    },
    {
      Header: 'RESDIT',
      columns: [
        new MultilineNumberGroupedColumn('74', 'resdit.resdit74s', true, 'resdit.pct74s')
          .withTotalHeader(sumOfGroupTotals, 'bg-total-darkGrey')
          .withShow(mode === Resdit7421PerformanceLocationReportMode.number),
        new MultilineNumberGroupedColumn('21', 'resdit.resdit21s', true, 'resdit.pct21s')
          .withTotalHeader(sumOfGroupTotals, 'bg-total-darkGrey')
          .withShow(mode === Resdit7421PerformanceLocationReportMode.number),
        new MultilinePercentageGroupedColumn('% 74', 'resdit.pct74s', true, 'resdit.resdit74s')
          .withTotalHeader(totalRowPercentageWithGrandTotals(['resdit.resdit74s', 'cardit.totals']), 'bg-total-darkGrey')
          .withShow(mode === Resdit7421PerformanceLocationReportMode.percentage),
        new MultilinePercentageGroupedColumn('% 21', 'resdit.pct21s', true, 'resdit.resdit21s')
          .withTotalHeader(totalRowPercentageWithGrandTotals(['resdit.resdit21s', 'cardit.totals']), 'bg-total-darkGrey')
          .withShow(mode === Resdit7421PerformanceLocationReportMode.percentage),
      ],
    },
  ];
};
